import { useContext, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import moment from "moment";

function Landing() {
	const userCtx = useContext(UserContext);
	const { t } = useTranslation();
	const navigate = useNavigate();
	var updatedAt = "";
	const [searchParams, setSearchParams] = useSearchParams();
	var redirectPath = searchParams.get("path");
	useEffect(() => {
		userCtx.clearStorage();
      	userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.addLang("");
		userCtx.addIsSubscriptionValid(false);
		userCtx.addTosTimeStamp("");
		userCtx.addEnabledMFA(0);
		fetchTerms();
	}, []);
  	
  	function fetchTerms() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetTerms","/Service/StaticHelper/GetTerms", requestOptions, getTermsSuccess, getTermsFail);
		} catch (error) {
		   	navigate("/home",{
		        state: {
		            	errorMessage: error.message,
		        	},
		     });
		}
	}
	function getTermsFail(redirect){
		navigate("/home",{
		        state: {
		            	errorMessage: t("error.getTermsFailed"),
		        	},
		     });
  	}
	function getTermsSuccess(responseData){
	  	var termsResponse;
	  	if (responseData) {
	    	termsResponse = responseData.getTermsResponse;
	     	if (termsResponse && termsResponse.errorCode === "0") {
				 updatedAt = termsResponse.terms.updatedAt;
				 checkAuth();
	      	}
	 	 }
	}
	function checkAuth() {
	   	const requestOptions = {
	         credentials: "same-origin",
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify({ "source": "web" }),
	  	};
	  	try{
         	FetchUtil.fetchAPI("CheckAuth","/Service/StaticNav/CheckAuth", requestOptions, checkAuthSuccess, checkAuthFail);
      	} catch (error) {
         	navigate("/home",{
	        	state: {
	            	errorMessage: error.message,
	        	},
	     	});
      	}
	}
	function checkAuthFail(redirect){
		navigate("/home",{
		        state: {
		            	errorMessage: t("error.userAuthFailed"),
		        	},
		     });
  	}
  	
  	function checkAuthSuccess(responseData){
		let logonServiceResponse;
      	if (responseData) {
			logonServiceResponse = responseData.logonServiceResponse;
			if(! logonServiceResponse){
				logonServiceResponse = responseData.logonResponse;
			}
			let currTermsUpdatedAt = moment(updatedAt, 'YYYY-MM-DD HH:mm:ss');
	        if (logonServiceResponse && logonServiceResponse.errorCode === "0") {
				let currTOSTimeStamp = moment(logonServiceResponse.tosTimeStamp, 'MM/DD/YYYY HH:mm');
				userCtx.addUserName(logonServiceResponse.userName);
				userCtx.addLoggedInUserId(logonServiceResponse.userId);
				userCtx.addRole(logonServiceResponse.userRole);
				userCtx.addIsAuthenticated(true);
				userCtx.addLang(logonServiceResponse.userLanguage);
				userCtx.addIsSubscriptionValid(logonServiceResponse.subscriptionValid);
				userCtx.addTosTimeStamp(logonServiceResponse.tosTimeStamp);
				userCtx.addEnabledMFA(logonServiceResponse.enabledMFA);
				if(currTermsUpdatedAt && currTermsUpdatedAt.isValid()){
					if(currTOSTimeStamp && currTOSTimeStamp.isValid() && currTermsUpdatedAt.isAfter(currTOSTimeStamp) ){
						navigate("/termsSubmit");
					} else if(!currTOSTimeStamp ||!currTOSTimeStamp.isValid()){
						navigate("/termsSubmit");
					} else {
						if(redirectPath){
						  navigate(""+redirectPath);
						} else {
						  navigate("/home_signin");
						}
					}
				}else{
					navigate("/home_signin");
				}
					
	        } else if (logonServiceResponse.errorCode === "114"){
				navigate("/home",{
			        state: {
			            	errorMessage: t("error.sessionTimeout"),
			        	},
			     });
			} else if (logonServiceResponse.errorCode === "1"){
				navigate("/home",{
			        state: {
			            	errorMessage: "",
			        	},
			     });
			} else {
				navigate("/home",{
			        state: {
			            	errorMessage: t("error.userAuthFailed") + " " +logonServiceResponse.errorMessage,
			        	},
			     });
			  	
	        }
      	}
  	}
	    
  	return (
	    <div />
  	);
}
export default Landing;
